import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import HomePage from '../components/main/HomePage';
import Login from '../components/intranet/Login/LoginPage';
import PasswordReset from '../components/intranet/Login/PasswordReset';
import Register from '../components/intranet/Login/RegisterPage';
import ResetPasswordForm from '../components/intranet/Login/ResetPasswordForm';
import OrderManager from '../components/apps/OrderManager/OrderManager';
import WebApps from '../components/apps/WebApps';
import BlogListKevin from '../components/intranet/Blogs/Posts/Kevin/BlogListKevin';
import BlogListNews from '../components/intranet/Blogs/Posts/News/BlogListNews';
import PostUploadPage from '../components/intranet/Blogs/Posts/Uploader/PostUploadPage';
import MarketingMaterials from '../components/intranet/Marketing/MarketingMaterials';
import ReactGA from 'react-ga4';
import Dashboard from '../components/dashboards/Dashboard';
import Header from '../components/main/Header';
import BlogListEHS from '../components/intranet/Blogs/Posts/EHS/BlogListEHS';
import { useAuth } from '../context/AuthContext';
import BlogListIT from '../components/intranet/Blogs/Posts/ITAlerts/BlogListIT';
import SmartShipperBlacklist from '../components/apps/SmartShipper/SmartShipperBlacklist';
import LicensesPage from '../components/apps/Licenses/LicensesPage';
import SftpPage from '../components/apps/EHS_sftp/SftpPage';
import AzureStoragePage from '../components/apps/azure-storage/AzureStoragePage';
import SharePointHRPage from '../components/apps/SharePointHR/SharePointHRPage';
import SharePointITPage from '../components/apps/SharePointIT/SharePointITPage';
import SsoDebug from '../pages/SsoDebug';
import SharePointComsPage from '../components/apps/SharePointComs/SharePointComsPage';
import SharePointFinancePage from '../components/apps/SharePointFinance/SharePointFinancePage';


// ✅ SUA System Components
import SuaGenerator from '../components/apps/SUA/SuaGenerator';
import VendorManagement from '../components/apps/SUA/VendorManagement';         // ✅ NEW
import PaymentRecordsPage from '../components/apps/SUA/PaymentRecordsPage';

// Initialize Google Analytics
ReactGA.initialize('G-41QLH62W9Y');

// Track page views
const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);
};

const AppRoutes = () => {
  usePageTracking();
  const { loading } = useAuth();

  if (loading) {
    return <p style={{ marginTop: '20px', textAlign: 'center' }}>Loading...</p>;
  }

  return (
    <>
      <Header />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/reset-password/:uidb64/:token" element={<ResetPasswordForm />} />
        <Route path="/sso-debug" element={<SsoDebug />} />

        {/* Private Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/ehs" element={<BlogListEHS />} />
          <Route path="/order_manager" element={<OrderManager />} />
          <Route path="/smartshipper_blacklist" element={<SmartShipperBlacklist />} />
          <Route path="/webapps" element={<WebApps />} />
          <Route path="/it" element={<BlogListIT />} />

          {/* Kevin's Corner */}
          <Route path="/kevins-corner" element={<BlogListKevin />} />

          {/* News */}
          <Route path="/news" element={<BlogListNews />} />

          {/* Uploads & Marketing */}
          <Route path="/post_upload" element={<PostUploadPage />} />
          <Route path="/marketing-materials" element={<MarketingMaterials />} />

          {/* Dashboard */}
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Software Licenses */}
          <Route path="/licenses" element={<LicensesPage />} />

          {/* SFTP File Manager */}
          <Route path="/ehs_sftp" element={<SftpPage />} />

          {/* Azure Storage Manager */}
          <Route path="/azure-storage" element={<AzureStoragePage />} />

          {/* HR Documents (SharePoint) */}
          <Route path="/hr-documents" element={<SharePointHRPage />} />

          {/* IT Documents (SharePoint) */}
          <Route path="/it-documents" element={<SharePointITPage />} />

          {/* ===== SUA Payment System ===== */}
          <Route path="/sua" element={<SuaGenerator />} />
          <Route path="/vendors" element={<VendorManagement />} />              {/* ✅ NEW */}
          <Route path="/payment-records" element={<PaymentRecordsPage />} />

          {/* Communications (SharePoint) */}
          <Route path="/communications-and-policies" element={<SharePointComsPage />} />

          {/* Finance (SharePoint) */}
          <Route path="/finance-documents" element={<SharePointFinancePage />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
